function getNDay(day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds);
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "-" + tMonth + "-" + tDate;
}
function doHandleMonth(month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

function getYMMHMS(hsm) {
  let text = hsm ? hsm : " 00:00:00";
  let time = new Date();
  let y = conver(time.getFullYear());
  let m = conver(time.getMonth() + 1);
  let d = conver(time.getDate());
  return y + "-" + m + "-" + d + text;
}

function getYMMHMSV2(t) {
  let time = new Date(t);
  let y = conver(time.getFullYear());
  let m = conver(time.getMonth() + 1);
  let d = conver(time.getDate());
  let h = conver(time.getHours());
  let f = conver(time.getMinutes());
  let s = conver(time.getSeconds());
  return y + "-" + m + "-" + d + " " + h + ":" + f + ":" + s;
}

function getYMMV2() {
  let time = new Date();
  let y = conver(time.getFullYear());
  let m = conver(time.getMonth() + 1);
  let d = conver(time.getDate());
  return y + "-" + m + "-" + d ;
}
function conver(s) {
  return s < 10 ? "0" + s : s;
}

function getYM() {
  let time = new Date();
  let y = conver(time.getFullYear());
  let m = conver(time.getMonth() + 1);
  return y + "-" + m;
}

function monthDay(time) {
  var d = new Date(time);
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  var date = d.getDate();

  var d2 = new Date();
  var year2 = d2.getFullYear();
  var month2 = d2.getMonth() + 1;
  var date2 = d2.getDate();

  let num = 30;
  if (
    month == 1 ||
    month == 3 ||
    month == 5 ||
    month == 7 ||
    month == 8 ||
    month == 10 ||
    month == 12
  ) {
    num = 31;
  }
  if (month == 2) {
    if ((year % 100 != 0 && year % 4 == 0) || year % 400 == 0) {
      num = 29;
    } else {
      num = 28;
    }
  }
  let list = [];
  let isToday = false;
  for (let index = 0; index < num; index++) {
    if (year == year2 && month == month2 && index + 1 == date2) {
      isToday = true;
    } else {
      isToday = false;
    }
    list.push({
      day: year + "-" + conver(month) + "-" + conver(index + 1),
      isToday: isToday,
    });
  }
  return list;
}

function topMonth(time) {
  var date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth();
  if (month == 0) {
    month = 12;
    year -= 1;
  }
  var day = new Date(year, month, 0).getDate();
  return `${year}-${conver(month)}`;
}

function bottomMonth(time) {
  var date = new Date(time);
  var year = date.getFullYear();
  var month = date.getMonth()+2;
  if (month > 12) {
    month = 1;
    year += 1;
  }
  console.log(month,year)
  // var day = new Date(year, month, 0).getDate();
  return `${year}-${conver(month)}`;
}


export default {
  getNDay: getNDay, // 获取前n天
  getYMMHMS: getYMMHMS,
  getYMMHMSV2: getYMMHMSV2,
  getYMMV2: getYMMV2,
  getYM: getYM,
  monthDay: monthDay,
  topMonth: topMonth,
  bottomMonth:bottomMonth
};
